export const productImageOptions = (instance, options) => ({
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true
})